/**@description SAP stores boolean values as a LongTextStr but uses `'X'` to represent `true` and an empty string to represent false */
export enum SapBooleanEnum {
  True = 'X',
  False = '',
}

/**@description When building an SAP filter query string these are used to find value matches */
export enum SapFilterOperatorEnum {
  Equals = 'eq',
  GreaterThan = 'gt',
  GreaterThanOrEquals = 'ge',
  LessThan = 'lt',
  LessThanOrEquals = 'le',
}
